module.exports = __webpack_public_path__ + "img/download.789e9beb.png";